import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=129350f5&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=129350f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129350f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('129350f5')) {
      api.createRecord('129350f5', component.options)
    } else {
      api.reload('129350f5', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=129350f5&scoped=true&", function () {
      api.rerender('129350f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/menu/menu.vue"
export default component.exports